import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const questionsModel = [
  {
    field: 'zalud_earInfection_redFlagSymptoms',
    label: 'Are you experiencing any of the following right now? (Select all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Unusually stiff neck', key: 'stiff_neck' },
        {
          value:
            'Unusually severe headache, confusion, or feeling very unwell',
          key: 'severe_headache_confused'
        },
        {
          value: 'Drooping, weakness, or numbness of one side of the face',
          key: 'facial_drooping_weakness'
        },
        {
          value:
            'Severe ear pain WITH swelling, redness, or tenderness behind the ear',
          key: 'severe_pain_swelling_redness'
        },
        { value: 'Bloody drainage from the ear', key: 'bloody_drainage' },
        {
          value:
            'Hearing that disappeared suddenly in one ear over minutes to hours, WITHOUT pain or a blocked feeling',
          key: 'sudden_hearing_loss'
        },
        {
          value:
            'Redness or swelling of the outer ear itself, or spreading onto the face or neck',
          key: 'outer_ear_redness_swelling'
        },
        {
          value: 'New spinning dizziness (vertigo) or trouble walking straight',
          key: 'vertigo'
        },
        {
          value:
            'Trouble opening your mouth fully, or visible swelling of the face or jaw',
          key: 'trouble_opening_mouth'
        },
        { value: 'Vision changes or double vision', key: 'vision_changes' },
        { value: 'None of the above', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'zalud_earInfection_earHistory',
    label: 'Do any of these apply to you? (Select all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value: 'I have ear tubes (tympanostomy tubes) in place',
          key: 'ear_tubes'
        },
        {
          value: 'I have been told I have a hole or perforation in my eardrum',
          key: 'eardrum_perforation'
        },
        {
          value: 'Previous radiation treatment to the head or neck',
          key: 'prior_radiation'
        },
        {
          value: 'Previous ear surgery (other than ear tubes)',
          key: 'prior_ear_surgery'
        },
        { value: 'None of the above', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'zalud_earInfection_symptomDuration',
    label: 'How long have you had your symptoms?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: '1–3 days', key: '1_to_3_days' },
        { value: '4–7 days', key: '4_to_7_days' },
        { value: '8–14 days', key: '8_to_14_days' },
        { value: 'More than 2 weeks', key: 'more_than_2_weeks' },
        { value: 'More than 6 weeks', key: 'more_than_6_weeks' }
      ]
    }
  },
  {
    field: 'zalud_earInfection_fever',
    label: 'Do you currently have a fever?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'No fever', key: 'no_fever' },
        {
          value: 'Mild fever (100.4–102°F / 38–38.9°C)',
          key: 'mild_fever'
        },
        { value: 'High fever (≥102°F / ≥38.9°C)', key: 'high_fever' },
        { value: "I don't know", key: 'unknown' }
      ]
    }
  },
  {
    field: 'zalud_earInfection_earsAffected',
    label: 'Which ear(s) are affected?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Right ear only', key: 'right_ear_only' },
        { value: 'Left ear only', key: 'left_ear_only' },
        { value: 'Both ears', key: 'both_ears' }
      ]
    }
  },
  {
    field: 'zalud_earInfection_painSeverity',
    label: 'How would you rate your ear pain right now (0–10)?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: '0–3 (mild)', key: 'mild_0_3' },
        { value: '4–6 (moderate)', key: 'moderate_4_6' },
        { value: '7–10 (severe)', key: 'severe_7_10' }
      ]
    }
  },
  {
    field: 'zalud_earInfection_symptoms',
    label: 'Which symptoms are you experiencing? (Select all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Deep ear pain', key: 'deep_ear_pain' },
        {
          value:
            'Pain that worsens when tugging the outer ear or pressing the small flap in front of the ear canal',
          key: 'pain_tugging_ear'
        },
        { value: 'Itching in the ear canal', key: 'itching_ear_canal' },
        {
          value:
            'Feeling that the ear canal is swollen shut or completely blocked',
          key: 'ear_canal_swollen_blocked'
        },
        { value: 'Muffled or decreased hearing', key: 'muffled_hearing' },
        { value: 'Feeling of fullness or pressure', key: 'fullness_pressure' },
        { value: 'Thick or pus-like drainage', key: 'thick_pus_drainage' },
        { value: 'Watery or clear drainage', key: 'watery_clear_drainage' },
        { value: 'Ringing in the ear', key: 'ringing_in_ear' },
        { value: 'None of the above', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'zalud_earInfection_past7Days',
    label: 'In the past 7 days, have you: (Select all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value: 'Been swimming, surfing, diving, or used a hot tub',
          key: 'swimming_hot_tub'
        },
        {
          value: 'Had a cold, sinus infection, or sore throat',
          key: 'cold_sinus_sore_throat'
        },
        {
          value: 'Flown on an airplane or scuba dived',
          key: 'flown_scuba_dived'
        },
        {
          value:
            'Used cotton swabs, earplugs, hearing aids, or earbuds regularly',
          key: 'cotton_swabs_earplugs_earbuds'
        },
        {
          value: 'Injured the ear or had something get stuck in it',
          key: 'ear_injury_object'
        },
        { value: 'None of the above', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'zalud_earInfection_jawToothPain',
    label:
      'Do you have jaw pain, tooth pain, or pain that worsens with chewing?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_earInfection_dentalProcedures',
    label: 'Have you had any dental procedures within the last 14 days?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_earInfection_treatmentAttempts',
    label:
      'Have you already attempted to treat your ear symptoms? (Select all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value: 'Taken an oral antibiotic in the past 30 days',
          key: 'oral_antibiotic_30_days'
        },
        {
          value:
            'Used prescription ear drops for this episode without improvement',
          key: 'prescription_ear_drops_no_improvement'
        },
        {
          value: 'Used over-the-counter drops, oils, or home remedies',
          key: 'otc_drops_oils_home_remedies'
        },
        { value: 'Nothing yet', key: 'nothing_yet', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'zalud_earInfection_additionalComments',
    label:
      'Are there any additional symptoms or comments related to your current condition that were not covered in this form?',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'zalud_earInfection_additionalComments'
    }
  },
  {
    field: 'zalud_earInfection_consent',
    label: 'Consent',
    type: 'select',
    educationalSlide: `I consent that by submitting this form I acknowledge that the responses are truthful and accurate to the best of my knowledge, and understand that if I am or become pregnant, or use medications off-label, I should consult a qualified health care professional for individualized guidance.`,
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I have read the information and I DO NOT wish to proceed',
          class: 'option-decline',
          key: 'do_not_proceed'
        },
        {
          value:
            'I have read and understand the information and I wish to proceed',
          class: 'option-consent',
          key: 'proceed'
        }
      ]
    }
  },
  {
    field: 'zalud_earInfection_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    type: 'info',
    answer: {}
  },
  {
    class: 'ineligible',
    field: 'zalud_earInfection_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to continue based on your responses.",
    blockQuestionFlow: true,
    answer: {},
    type: 'info',
    isLast: true
  }
] as const;

export type ZaludEarInfectionQuestionFieldAnswers = Partial<
  QuestionAnswerMap<typeof questionsModel>
>;
export default questionsModel;
